import { MineralFertilisationGraph } from '../MineralFertilisationGraph/MineralFertilisationGraph';
import { MineralFertilisationNutrientsGraph } from '../MineralFertilisationNutrientsGraph/MineralFertilisationNutrientsGraphs';
import { MineralFertilisationTable } from '../MineralFertilisationTable/MineralFertilisationTable';
import { NoDataFound } from '../../shared/NoDataFound/NoDataFound';
import { useMineralFertilisationLogic } from './MineralFertilisation.logic';

export const MineralFertilisation = ({ showHistoryYears }: { showHistoryYears: boolean }) => {
    const { hasNoData } = useMineralFertilisationLogic();

    return hasNoData ? (
        <NoDataFound />
    ) : (
        <>
            <MineralFertilisationGraph showHistoryYears={showHistoryYears} />
            <MineralFertilisationNutrientsGraph showHistoryYears={showHistoryYears} />
            <MineralFertilisationTable showHistoryYears={showHistoryYears} />
        </>
    );
};
